<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Relationships</h1>
                    <div class="btns-container">

                        <a (click)="openModal('New', 0, ''  )" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            <i class="fas fa-plus text-white-50"> <span class="button-text">Create Relationship</span></i>
                        </a>
                    </div>

                </div>

                <div class="card shadow">

                    <div class="container-fluid">
                        <div style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #agGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [enableFilter]="true"
                                             [gridOptions]="gridOptions"
                                             [rowData]="data"
                                             [columnDefs]="dataHeaders"
                                             [enableSorting]="true"
                                             [floatingFilter]="true"
                                             [enableColResize]="true"
                                             (rowClicked)="onRowClicked($event)"
                                             (gridReady)="onGridReady($event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                             [rowSelection]="rowSelection"
                                             (rowSelected)="onRowSelected($event)"
                                             (selectionChanged)="onSelectionChanged($event)"
                                             [rowMultiSelectWithClick]="true"
                                             [suppressRowClickSelection]="true">
                            </ag-grid-angular>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--NEW RATER MODAL-->
<div id="createEditModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">{{action}} Relationship</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="row">
                    <div class="col-xs-12 col-md-2">
                        <label>Name:</label>
                    </div>
                    <div class="col-xs-12 col-md-10" style="padding: 0;">
                        <input #ratertName
                               (keypress)="preventSpace(ratertName.value, $event, 'raterName')"
                               id="raterName"
                               [(ngModel)]="name"
                               placeholder="Name"
                               type="text"
                               name="name"
                               value="" />
                    </div>
                </div>
                <!--<div class="row">
                    <div class="col-xs-12 col-md-2">
                        <label>Min:</label>
                    </div>
                    <div class="col-xs-12 col-md-10" style="padding: 0;">
                        <input #ratertMin
                               id="raterMin"
                               (keypress)="preventSpace(ratertName.value, $event, 'Min')"
                               [(ngModel)]="min"
                               min="0"
                               type="number"
                               name="min"
                               value="1" />
                    </div>
                </div>-->

            </div>

            <div class="modal-footer">
                <input data-dismiss="modal" type="button" class="btn btn-secondary" name="close" value="Cancel" />
                <input *ngIf="action == 'Edit'" (click)="openConfirmationModal()" type="button" class="btn btn-red waves-effect" value="Delete" />
                <input (click)="saveRater()" type="button" class="btn btn-primary waves-effect" value="Save" />

                <!--<a *ngIf="action == 'Edit'" (click)="openConfirmationModal()" style="margin-left: 25px;" class="d-none d-sm-inline-block btn btn-sm btn-red shadow-sm margin-right-5">
                    <i class="fas fa-trash text-white-50"> <span class="button-text">Delete</span></i>
                </a>
                <a (click)="saveRater()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm   ">
                    <i class="fas fa-save text-white-50"> <span class="button-text">Save</span></i>
                </a>-->
            </div>
        </div>
    </div>
</div>


 
<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="confirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Relationship</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Relationship</b>?</p>
            </div>

            <div class="modal-footer">
                <div class="">
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="deleteRaterType()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>